module.exports = __webpack_public_path__ + "img/img_asset_valve_flow_meter.ad3fcc06.svg";